const ko: Record<string, string> = {
  "Virtual Try-On": "가상 피팅",
  "Find Your Size & See It On You": "사이즈를 찾고 입어보세요",
  "See Your Fit": "핏 확인하기",
  "Check your size, then try it on virtually": "사이즈를 확인하고 가상으로 입어보세요",
  "Get Your Size": "사이즈 확인",
  "Instant fit suggestion": "즉시 핏 제안",
  "Try It On": "입어보기",
  "See how it looks on you": "어떻게 보이는지 확인",
  "Find My Size": "내 사이즈 찾기",
  "Takes less than a minute": "1분도 걸리지 않아요",
  "Upload a full body photo": "전신 사진 업로드",
  "JPEG, PNG or WebP (max 10MB)": "JPEG, PNG 또는 WebP (최대 10MB)",
  "Your photo": "내 사진",
  "Let's find your best fit": "최적의 핏을 찾아보세요",
  "Centimeters": "센티미터",
  "Inches": "인치",
  "Load saved profile...": "저장된 프로필 불러오기...",
  "HEIGHT": "키",
  "WEIGHT": "체중",
  "feet": "피트",
  "inches": "인치",
  "cm": "cm",
  "kg": "kg",
  "lbs": "파운드",
  "in": "인치",
  "How to measure": "측정 방법",
  "Hide guide": "가이드 숨기기",
  "I know my measurements": "치수를 알고 있어요",
  "Not sure? Use height & weight instead": "모르겠다면 키와 체중으로",
  "Please fill in height and weight": "키와 체중을 입력해주세요",
  "Please fill in all required fields": "모든 필수 항목을 입력해주세요",
  "Next": "다음",
  "Analyzing your size...": "사이즈 분석 중...",
  "SUGGESTED SIZE": "제안 사이즈",
  "NOT SUGGESTED": "제안 아님",
  "Edit measurements": "치수 수정",
  "Size guide": "사이즈 가이드",
  "Your fit": "나의 핏",
  "Your Suggested Size": "제안 사이즈",
  "Your measure": "내 치수",
  "within range": "범위 내",
  "too tight": "너무 타이트",
  "tight": "타이트",
  "a bit tight": "약간 타이트",
  "too loose": "너무 루즈",
  "loose": "루즈",
  "a bit loose": "약간 루즈",
  "See fit on your photo": "사진에서 핏 확인",
  "Hide visual fit": "핏 표시 숨기기",
  "Analyzing...": "분석 중...",
  "Try it on": "입어보기",
  "SIZE CHART": "사이즈 차트",
  "YOUR ESTIMATED MEASUREMENTS": "추정 치수",
  "Edit": "수정",
  "Download": "다운로드",
  "Size chart": "사이즈 차트",
  "Preparing your image...": "이미지 준비 중...",
  "Analyzing body proportions...": "체형 분석 중...",
  "Matching garment to your photo...": "의류를 사진에 맞추는 중...",
  "Generating virtual try-on...": "가상 피팅 생성 중...",
  "Refining details...": "세부 조정 중...",
  "Almost there...": "거의 완료...",
  "Complete!": "완료!",
  "This usually takes 15-25 seconds": "보통 15~25초 소요됩니다",
  "Something went wrong": "오류가 발생했습니다",
  "Try Again": "다시 시도",
  "We couldn't find a matching size for you": "맞는 사이즈를 찾지 못했습니다",
  "Please try the manual measurement screen so we can calculate your fit from your measurements.": "수동 측정 화면에서 치수를 입력하면 해당 측정값으로 핏을 계산할 수 있습니다.",
  "Try manual measurements": "수동 측정 사용",
  "SDK not configured. Please provide an API key.": "SDK가 설정되지 않았습니다. API 키를 입력해주세요.",
  "Please upload a JPEG, PNG, or WebP image.": "JPEG, PNG 또는 WebP 이미지를 업로드해주세요.",
  "Image must be under 10MB.": "이미지는 10MB 이하여야 합니다.",
  "Try-on generation failed": "피팅 생성 실패",
  "Failed to start try-on": "피팅 시작 실패",
  "No product image found. Please set the product-image attribute.": "상품 이미지를 찾을 수 없습니다. product-image 속성을 설정해주세요.",
  "Powered by": "Powered by",
  "My Profiles": "내 프로필",
  "History": "기록",
  "No saved profiles yet.": "저장된 프로필이 없습니다.",
  "No history yet.": "기록이 없습니다.",
  "Product": "상품",
  "Women's": "여성",
  "Men's": "남성",
  "Profiles": "프로필",
  "Women's Profile": "여성 프로필",
  "Men's Profile": "남성 프로필",
  "Height": "키",
  "Weight": "체중",
  "Chest": "가슴둘레",
  "Bust": "버스트",
  "Waist": "허리",
  "Hips": "엉덩이",
  "Shoulders": "어깨",
  "Sleeve": "소매",
  "Inseam": "안쪽 솔기",
  "Neck": "목둘레",
  "Foot": "발",
  "Shoe EU": "신발 EU",
  "Shoe US": "신발 US",
  "Shoe UK": "신발 UK",
  "Saved": "저장됨",
  "Delete Profile": "프로필 삭제",
  "Shoe size (US)": "신발 사이즈 (US)",
  "Shoe size (UK)": "신발 사이즈 (UK)",
  "Shoe size (EU)": "신발 사이즈 (EU)",
  "Generating...": "생성 중...",
  "Foot length": "발 길이",
  "Size": "사이즈",
  "Try on size": "사이즈 입어보기",
  "e.g.": "예)",
  "Drop your photo here or click to upload": "사진을 여기에 놓거나 클릭하여 업로드",
  "This usually takes 15-20 seconds": "보통 15~20초 소요됩니다",
  "Try-on result": "피팅 결과",
  "Try Another": "다시 시도",
  "Back": "뒤로",
  "You": "내 치수",
  "Garment": "의류",
  "Your Height": "키",
  "Your Weight": "체중",
  "Drag or scroll to set your height": "드래그 또는 스크롤하여 키를 설정하세요",
  "Drag or scroll to set your weight": "드래그 또는 스크롤하여 체중을 설정하세요",
  "Enter height and weight first": "먼저 키와 체중을 입력하세요",

  // ── Field labels ──
  "Lens Width": "렌즈 너비",
  "Bridge": "브릿지",
  "Arm Length": "다리 길이",
  "Head Circumference": "머리 둘레",
  "Face Width": "얼굴 너비",
  "Temple": "다리",
  "Around widest point": "가장 넓은 부분 주위",
  "Foot Length": "발 길이",
  "Shoulder": "어깨",
  "Thigh": "허벅지",
  "Hip": "엉덩이",

  // ── Units ──
  "Millimetre": "밀리미터",
  "Centimetre": "센티미터",
  "Millimeters": "밀리미터",

  // ── Fit descriptors ──
  "Tight": "꽉 끼는",
  "Loose": "헐렁한",
  "Short": "짧은",
  "Long": "긴",
  "✓ Fit": "✓ 적합",
  "too short": "너무 짧음",
  "too long": "너무 김",
  "a bit short": "약간 짧음",
  "a bit long": "약간 김",

  // ── Length pills ──
  "Length": "길이",
  "Length Adjustment": "길이 조절",
  "Regular": "보통",
  "Big": "빅",
  "Big & Tall": "빅 & 톨",

  // ── Misc ──
  "preview": "미리보기",

  // ── BodyProfileView — photo upload area (left section) ──
  "Upload your photo": "사진 업로드",
  "Upload a photo": "사진 업로드",
  "Click or drag a full-body photo": "전신 사진을 클릭하거나 드래그하세요",
  "Or upload a photo for AI sizing": "또는 AI 사이징을 위한 사진을 업로드하세요",
  "Photo": "사진",
  "How to take a good photo": "좋은 사진 찍는 방법",
  "How to take the best photo": "최고의 사진 찍는 방법",
  "Do": "권장사항",
  "Don't": "주의사항",
  "Quick Tip": "빠른 팁",
  "The simpler your photo is, the more accurate your virtual try-on results will be.": "사진이 단순할수록 가상 피팅 결과의 정확도가 높아집니다.",
  "Choose a plain background (a light wall is ideal)": "단색 배경을 선택하세요(밝은 벽이 이상적입니다)",
  "Stand facing the camera with your full body in frame": "전신이 화면에 들어오도록 카메라를 향해 서세요",
  "Stand straight and still, arms relaxed by your sides": "팔을 자연스럽게 내리고 똑바로 서서 움직이지 마세요",
  "Stand with your HEELS against a wall for best accuracy": "정확도를 위해 발뒤꿈치를 벽에 붙이고 서세요",
  "Use natural or even lighting (e.g. near a window)": "자연광이나 균일한 조명을 사용하세요(예: 창가)",
  "Wear fitted, simple clothing (e.g. neutral colors)": "몸에 맞는 단순한 옷을 입으세요(예: 무채색)",
  "Don't wear loose, baggy, or layered clothing": "헐렁하거나 겹쳐 입은 옷은 피하세요",
  "Don't sit, pose, or bend your body": "앉거나 포즈를 취하거나 몸을 굽히지 마세요",
  "Don't use strong backlighting": "강한 역광은 사용하지 마세요",
  "Don't take mirror photos or selfies": "거울 사진이나 셀카는 찍지 마세요",
  "Don't apply filters, effects, or edits": "필터, 효과, 편집을 적용하지 마세요",

  // ── Age gate ──
  "Are you 18 or older?": "만 18세 이상이신가요?",
  "Yes": "예",
  "No": "아니요",
  "Please confirm your age": "나이를 확인해 주세요",
  "Please confirm that the person in the photo is 18 or older before uploading.": "업로드하기 전에 사진의 인물이 만 18세 이상임을 확인해 주세요.",
  "Under 18 — can't process this photo.": "18세 미만 — 이 사진을 처리할 수 없습니다.",
  "This photo appears to be of a minor. Please upload a photo of someone 18 or older.": "이 사진은 미성년자로 보입니다. 만 18세 이상인 사람의 사진을 업로드해 주세요.",
  "Different photo needed": "다른 사진이 필요합니다",
  "Try another photo": "다른 사진을 시도해 보세요",

  // ── Photo step controls ──
  "Continue": "계속",
  "Analyze My Size": "내 사이즈 분석",
  "Analyzing photo…": "사진 분석 중…",
  "Details": "세부정보",
  "Image must be under 10MB": "이미지는 10MB 이하여야 합니다",
  "Please upload an image file": "이미지 파일을 업로드하세요",
  "Please upload a photo": "사진을 업로드하세요",
  "Prefer not to upload a photo?": "사진을 업로드하지 않으시겠습니까?",
  "Enter measurements manually": "직접 치수 입력",
  "Legal Notice": "법적 고지",
  "Your image will be used to generate a virtual try-on preview showing how selected items may look and fit. Images are processed securely and are not stored after generation.": "귀하의 이미지는 선택한 항목이 어떻게 보이고 맞을지를 보여주는 가상 피팅 미리보기를 생성하는 데 사용됩니다. 이미지는 안전하게 처리되며 생성 후에는 저장되지 않습니다.",

  // ── BodyProfileView — form (right section) ──
  "Body details": "신체 정보",
  "Your body details": "당신의 신체 정보",
  "Body Measurements": "신체 치수",
  "AGE": "나이",
  "years": "세",
  "Enter your height": "키를 입력하세요",
  "Enter your weight": "체중을 입력하세요",
  "Enter your bra size": "브라 사이즈를 입력하세요",
  "Please enter your height": "키를 입력하세요",
  "Please enter your weight": "체중을 입력하세요",
  "Please enter a valid height": "올바른 키를 입력하세요",
  "Please enter a valid weight": "올바른 체중을 입력하세요",
  "Please enter a valid height (100-250 cm)": "올바른 키를 입력하세요(100-250 cm)",
  "Please enter a valid weight (30-300 kg)": "올바른 체중을 입력하세요(30-300 kg)",
  "Please select both band and cup size": "밴드와 컵 사이즈를 모두 선택하세요",
  "Select your bra size": "브라 사이즈를 선택하세요",
  "BAND": "밴드",
  "BAND SIZE": "밴드 사이즈",
  "CUP": "컵",
  "CUP SIZE": "컵 사이즈",
  "BRA REGION": "브라 지역",
  "Imperial": "영국식",
  "Metric": "미터법",
  "These calibrate the AI — all required.": "이 항목들은 AI를 보정합니다 — 모두 필수입니다.",
  "Using": "사용 중",
  "start fresh": "새로 시작",
  "Close": "닫기",

  // ── Body shape questions ──
  "Which best describes your chest?": "가슴을 가장 잘 설명하는 것은?",
  "WHICH BEST DESCRIBES YOUR CHEST?": "가슴을 가장 잘 설명하는 것은?",
  "Which best describes your hips?": "엉덩이를 가장 잘 설명하는 것은?",
  "WHICH BEST DESCRIBES YOUR HIPS?": "엉덩이를 가장 잘 설명하는 것은?",
  "Which best describes your midsection?": "허리를 가장 잘 설명하는 것은?",
  "WHICH BEST DESCRIBES YOUR MIDSECTION?": "허리를 가장 잘 설명하는 것은?",
  "Which best describes your seat?": "엉덩이 모양을 가장 잘 설명하는 것은?",
  "WHICH BEST DESCRIBES YOUR SEAT?": "엉덩이 모양을 가장 잘 설명하는 것은?",
  "Average": "평균",
  "Narrow": "좁음",
  "Broad": "넓음",
  "Curvy": "곡선미",
  "A slimmer, narrower chest build": "더 가늘고 좁은 가슴",
  "A moderate, proportionate chest": "보통의 균형잡힌 가슴",
  "A wider, more muscular chest": "더 넓고 근육질의 가슴",
  "A flatter midsection with minimal protrusion": "최소한의 돌출이 있는 평평한 허리",
  "A moderate, natural midsection shape": "보통의 자연스러운 허리",
  "A fuller, more rounded midsection": "더 풍만하고 둥근 허리",
  "A flatter backside with less projection": "돌출이 적은 평평한 엉덩이",
  "A moderate, natural backside shape": "보통의 자연스러운 엉덩이",
  "A fuller, more rounded backside": "더 풍만하고 둥근 엉덩이",

  // ── Photo step — profile photo preload pill ──
  "Loaded from profile": "프로필에서 불러옴",
  "Clear": "지우기",
};
export default ko;
